import React, { Component } from 'react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { Grid, Box, LinearProgress } from '@mui/material';

import styles from './styles';
import AssignmentList from './AssignmentList';
import moment from 'moment';
import AssignmentsStats from './AssignmentsStats';

class DispatchAssignmentListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
    };
  }

  componentDidMount() {
    const { assignmentStore } = this.props.store;
    const { day, region, assignmentId } = this.props.match.params;

    if (day) {
      if (day === 'today') {
        assignmentStore.date = moment().format('YYYY-MM-DD');
      } else {
        assignmentStore.date = moment(day).format('YYYY-MM-DD');
      }
    }
    if (region && region !== 'all') {
      assignmentStore.regions = region.toUpperCase().split(',');
    }

    assignmentStore.loadAssignments();

    if (assignmentId) {
      assignmentStore.loadAssignment(parseInt(assignmentId, 10));
    }
  }

  componentDidUpdate() {
    const { store } = this.props;
    const { loadingAssignments } = store.assignmentStore;
    if (this.state.collapse && loadingAssignments) {
      this.setState({ collapse: false });
    }
  }

  onCollapse = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    const { collapse } = this.state;
    const { store } = this.props;
    const { loadingAssignments } = store.assignmentStore;
    const bottomHeight = collapse ? 50 : 330;

    if (loadingAssignments) {
      return (
        <Box sx={styles.container}>
          <LinearProgress color="primary" />
        </Box>
      );
    }

    return (
      <Box sx={styles.container}>
        <Grid container direction="column" sx={styles.gridContainer}>
          <Grid size="grow" sx={styles.gridSection} style={{ maxHeight: `calc(100% - ${bottomHeight}px)` }}>
            <AssignmentList />
          </Grid>
          <Grid sx={{ ...styles.bottomSection, ...styles.gridSection }} style={{ maxHeight: bottomHeight }}>
            <AssignmentsStats onCollapse={this.onCollapse} />
          </Grid>
        </Grid>
      </Box>
    );
  }
}

const DispatchAssignmentListContainerCompose = compose(inject('store'), observer)(DispatchAssignmentListContainer);

export default withRouter(DispatchAssignmentListContainerCompose);
